import { API } from "../auth/authApi";

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

export const getMeetingsApi = (params) => {
  return API.get("/meeting/all/admin", { params });
};